export default __webpack_public_path__ + "static/media/Thursday_02.ca604487.png";